<div class="card" *ngIf="hasFiltri" >
<div  class="card-body align-middle">
  <div class="row align-middle">
    <div class="col-lg-2 form-group">
      <label class="mb-0 text-dark">Inizio</label>
      <input type="date" #inizio = "ngModel"  [(ngModel)]="Filtri.inizio" (ngModelChange)="refreshTable(1)" name="inizio" class="form-control">
    </div>
    <div class="col-lg-2 form-group">
      <label class="mb-0 text-dark">Fine</label>
      <input type="date" #fine = "ngModel"  [(ngModel)]="Filtri.fine" (ngModelChange)="refreshTable(1)" name="fine" class="form-control">
    </div>
    <div class="col-lg-1 align-middle">
      <label class="control-label col-form-label">Periodo</label>
      &nbsp;
      <input type="checkbox" #periodo = "ngModel" [(ngModel)]="Filtri.periodo" (ngModelChange)="refreshTable(1)" name="periodo" >
    </div>
  </div>
</div>
</div>
<div class="d-md-flex align-items-center bg-white p-3">
    <span class="d-flex align-items-center p-2 ">
      <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> Fatture:</h5>
      <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14">{{collectionSize}}</span>
    </span>
  <div class="ml-auto mt-3 mt-md-0">
    <button *ngIf="permission.isPermitted('gestione-fatture') && isAddEnabled"(click)='Edit()' type="button" class="btn btn-cyan rounded-pill py-2" ><i
        class="fas fa-plus  font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">Aggiungi</span>
    </button>
  </div>
</div>
<div class="table-responsive">
  <table class="table bg-white table-hover align-middle mb-0 no-wrap">
    <thead>
      <tr>
        <th>Progressivo</th>
        <th >Nominativo</th>
        <th>Numero</th>
        <th>Progetto</th>
        <th scope="col">Data Emissione</th>
        <th scope="col" *ngIf="permission.isPermitted('gestione-fatture')">Azioni</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of List | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
        <td (click)='Edit(item)'>
          <span class="font-14">{{item.progressivo}}</span>
        </td>
        <td (click)='Edit(item)'>
          <span class="font-14">{{item.nominativo}}</span>
        </td>
        <td (click)='Edit(item)'>
          <span class="font-14">{{item.numero}}</span>
        </td>
        <td (click)='Edit(item)'>
          <span *ngIf="item.progettoObject" class="font-14">{{item.progettoObject.label}}</span>
        </td>
        <td class="align-middle" (click)='Edit(item)'>
          <span>
            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
              <i-feather name="file-text" class="feather-sm"></i-feather>
            </span>
            {{ item.data_emissione | date: 'dd/MM/yyyy'}}
          </span>
        </td>
        <td class="align-middle" *ngIf="permission.isPermitted('gestione-fatture')">
          <a href="javascript:void(0)" ngbTooltip="Modifica" class="link font-16 text-info font-medium mr-2"
            (click)="Edit(item)">
            <i-feather name="edit-3" class="feather-sm"></i-feather>
          </a>
          <a href="javascript:void(0)" ngbTooltip="Elimina"
            class="link font-16 text-danger font-weight-bold" (click)='delete(item)'>
            <i-feather name="trash-2" class="feather-sm"></i-feather>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>


<div class="d-flex justify-content-center p-2 pt-3 bg-white border-top">
  <ngb-pagination (pageChange)="getPage($event)" id="paginationComponent" [maxSize]="10"
    [collectionSize]="collectionSize" [pageSize]="pageSize">
  </ngb-pagination>
</div>


